import React, { useState } from 'react';
import Button from '../shared/Button';
import { HiMenuAlt1 } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import { selectTotalQuantity } from '../features/bucket/bucketSlice';
import { Link } from 'react-router-dom';
import DeliveryModal from './modals/DeliveryModal';
import Sidebar from "./Sidebar"
import PickupModal from './modals/PickupModal';

const Navbar = () => {
  const bucket = useSelector((state) => state.bucket.items);
  const [isDeliveryModalOpen, setIsDeliveryModalOpen] = useState(false);
  const [isPickupModalOpen, setIsPickupModalOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const openDeliveryModal = () => {
    setIsDeliveryModalOpen(true);
  };
  const openPickupModal = () => {
    setIsPickupModalOpen(true);
  };

  
  const totalQuantity = useSelector(selectTotalQuantity);

  return (
    <>
    <div className="bg-light-primary p-4 z-10 shadow-lg">
      <div className="container mx-auto flex justify-between items-center flex-wrap">
        <div className="flex space-x-4 items-center  flex-nowrap ">
          <HiMenuAlt1 size={32} className="cursor-pointer" onClick={() => setSidebarOpen(!sidebarOpen)} />
          <Link to={"/"} className="text-white text-xl font-bold">
            <img src="/logo.png" alt="logo" />
          </Link>
          <Button type="outlined" data="DELIVERY" icon="/rider.png" onClick={openDeliveryModal} />
          <Button
            type="outlined"
            data="PICKUP"
            icon="/pickup.png"
            styles="border-none bg-light-tertiary"
            onClick={openPickupModal}
          />
        </div>
        <div className="flex flex-nowrap space-x-4 mr-8 relative md:mt-0 lg:mt-0 mt-2">
          <span className="absolute bottom-2 left-8 text-sm font-semibold">
            {totalQuantity}
          </span>
          <Link to={"/bucket"}>
              <img src="/Bucket.png" alt="bucket" className="w-10" />
          </Link>
          <Link to="/login">
          <Button type="solid" data="LOGIN" />
          </Link>
        </div>
      </div>
    </div>
    {isDeliveryModalOpen && (
    <DeliveryModal isModalOpen={isDeliveryModalOpen} setIsModalOpen={setIsDeliveryModalOpen} />)}
    {isPickupModalOpen && (
    <PickupModal isModalOpen={isPickupModalOpen} setIsModalOpen={setIsPickupModalOpen} />)}
    {sidebarOpen && (
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}/>
    )}
    </>
  );
};

export default Navbar;
